<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import UiStatusPill from '@/Components/UI/UiStatusPill.vue'

const props = defineProps({ status: { type: String, required: true } })
const { t } = useI18n()

const MAP = {
  paid: { tone: 'ok', icon: 'check' },
  partial: { tone: 'warn', icon: '' },
  unpaid: { tone: 'danger', icon: '' },
  written_off: { tone: 'muted', icon: '' },
}

const cfg = computed(() => MAP[props.status] || MAP.unpaid)
const label = computed(() => t(`rentals.payment.${props.status}`))
</script>

<template>
  <UiStatusPill
    :tone="cfg.tone"
    variant="soft"
    :icon="cfg.icon"
    :label="label"
  />
</template>
